export default __webpack_public_path__ + "static/media/envelope-b.d8b532fa.svg";